import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/taches`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const tachesApi = {
  getAll: (params) => api.get('/', { params }),
  getStats: () => api.get('/stats'),
  getCategories: () => api.get('/categories'),
  create: (data) => api.post('/', data),
  update: (id, data) => api.put(`/${id}`, data),
  remove: (id) => api.delete(`/${id}`),
};

export default tachesApi;
